import { Link } from '@amzn/awsui-components-core';
import { convertEntities } from '@amzn/awscat-editor';
import { ContentMetadata, ContentType } from '@amzn/awscat-pattern-library-service-model';
import React, { useContext } from 'react';
import { AppContext } from '../../contexts/AppContext';
import { getContentPath } from '../../common/ContentPaths';

interface Props {
  contentId: string;
  metadata: ContentMetadata;
}

const WorkflowViewerAdminLink: React.FunctionComponent<Props> = (props: Props) => {
  const { contentId, metadata } = props;
  const appContext = useContext(AppContext);

  if (metadata.contentType === ContentType.Post) {
    return (
      <Link variant="secondary" href={`/post-viewer/${contentId}`}>
        {convertEntities(metadata.contentName, appContext.entities)}
      </Link>
    );
  } else {
    return (
      <Link variant="secondary" href={getContentPath({ contentId, mode: 'draft', role: 'admin' })}>
        {convertEntities(metadata.contentName, appContext.entities)}
      </Link>
    );
  }
};

export default WorkflowViewerAdminLink;
